import { sendCustomEvent } from '@Analytics';
import { FeedbackSignal, GeneratedFile } from '@Models';
import { markActedOnLastAnswer } from '../../Helpers/Agents/lastAnswer';
import { sendSignal } from '../../Helpers/Agents/signals';
import { useFileDownload } from './useFileDownload';

// Single download path for every generated-file surface (chip, image card, lightbox).
export const useGeneratedFileDownload = (conversationId: string, timestamp: string, file: GeneratedFile) => {
  const { downloadFile, formatFileSize } = useFileDownload();

  const download = () =>
    downloadFile.mutate(
      { conversationId, timestamp, fileName: file.file_name },
      {
        onSuccess: () => {
          // `file_type` is a MIME string; the file name can carry client data.
          sendCustomEvent('AGENT_FILE_DOWNLOAD', { fileType: file.file_type });
          sendSignal(conversationId, timestamp, FeedbackSignal.DOWNLOAD);
          markActedOnLastAnswer(conversationId, timestamp);
        },
      },
    );

  return { download, isPending: downloadFile.isPending, error: downloadFile.error, formatFileSize };
};

export default useGeneratedFileDownload;
